import ModelTestView from '../components/ModelTest/ModelTestView.html';
import { ModelTestController } from '../components/ModelTest/ModelTestController';
export class ModelTestProcessor {
    static $inject = ['$document', 'ApplicationService2', 'SidebarContentService'];
    constructor($document, ApplicationService2, SidebarContentService) {
        'ngInject';
        this.$document = $document;
        this.ApplicationService2 = ApplicationService2;
        this.SidebarContentService = SidebarContentService;
    }
    open() {
        return this.SidebarContentService.showSidebar({
            template: ModelTestView,
            controller: ModelTestController,
            controllerAs: '$ctrl',
            appendToElement: this.$document[0].getElementById('right-sidebar'),
            inputs: {
                ApplicationService2: this.ApplicationService2,
            },
        });
    }
}
ModelTestProcessor.$inject = ['$document', 'ApplicationService2', 'SidebarContentService'];
